import { Checkbox } from "@onclicks/sharedcomponents/FieldForm/Checkbox";
import { Country } from "@onclicks/sharedcomponents/FieldForm/Country/Country";
import { Email } from "./Email";
import { Message } from "@onclicks/sharedcomponents/FieldForm/Message";
import { Number } from "./Number";
import { Select } from "./Select";
import { State } from "@onclicks/sharedcomponents/FieldForm/State/State";
import { Text } from "./Text";
import { Textarea } from "./Textarea";

export const fields = {
  checkbox: Checkbox,
  country: Country,
  email: Email,
  message: Message,
  number: Number,
  select: Select,
  state: State,
  text: Text,
  textarea: Textarea,
};
